import React, { useState } from 'react';
import "../styles/infopage.scss"
import HeaderTwo from '../components/HeaderTwo/HeaderTwoSection';
import Footer from '../components/Footer/FooterSection';

const Contact: React.FC = () => {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    // const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!name.trim() || !message.trim()) return;

        // You can send this data to a backend or third-party service
        // console.log('Submitted:', { name, message });

        
        setName('');
        setMessage('');
    };

    return (
        <>
            <HeaderTwo></HeaderTwo>

            <div className="infopage content animate__animated animate__fadeIn animate__fast">

                <div className="section">
                    <h1>Contact Us</h1>
                    <div className="content_in">
                        <p>We'd love to hear from you. Please fill out the form below and we'll respond as soon as possible.</p>
                    </div>
                </div>

                <div className="section">
                    <form onSubmit={handleSubmit}>
                        <div className="content_in">
                            <div className="subsection">
                                <label htmlFor="name">Your Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            <div className="subsection">
                                <label htmlFor="message">Your Message</label>
                                <textarea
                                    id="message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Enter your message"
                                    rows={5}
                                    required
                                />
                            </div>

                            <div className="subsection">
                                <button type="submit" className='btn full'>Send Message</button>
                            </div>

                            {/* {submitted && (
                                <div className="subsection">
                                    <p className="success-message">Thank you! Your message has been sent.</p>
                                </div>
                            )} */}
                        </div>
                    </form>
                </div>
            </div>

            <Footer></Footer>
        </>
    );
};

export default Contact;

